import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/authActions';
import { getTranslate } from 'react-localize-redux';
import ActionButton from '../components/ActionButton';

const ResetPasswordPage = ({actions, translate, resetPasswordStatus, match}) => {
  const {userId, token} = match.params;
  const {resetPassword} = actions;
  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [validationErrors, setValidationErrors] = useState({
    match: false,
    len: false,
  });

  let matchErrorEl = null;
  if (validationErrors.match) {
    matchErrorEl = (
      <p className="err-info">{translate('password_err_match')}.</p>
    );
  }

  let passwordLenErrorEl = null;
  if (validationErrors.len) {
    passwordLenErrorEl = (
      <p className="err-info">{translate('password_err_len')}.</p>
    );
  }

  const submit = (event) => {
    event.preventDefault();
    if(newPassword.length < 8) {
      setValidationErrors({...validationErrors, len: true});
    }else if (repeatPassword !== newPassword) {
      setValidationErrors({...validationErrors, match: true});
    }else {
      resetPassword(userId, token, newPassword);
    }
  };

  return (
    <div className="reset-password-page">
      <Helmet>
        <title>{translate('page_title_reset_password')}</title>
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-md-12" style={{paddingTop: '10px'}}>
            <h2>{translate('reset_password_title')}</h2>
            <form onSubmit={submit}>
              <p>
                <label htmlFor="new-password">{translate('password_new')}:</label>
                <input type="password" value={newPassword} id="new-password" className="form-control"
                  onChange={(event) => setNewPassword(event.target.value)} />
              </p>
              {passwordLenErrorEl}
              <p>
                <label htmlFor="repeat-password">{translate('password_repeat')}:</label>
                <input type="password" value={repeatPassword} id="repeat-password" className="form-control"
                  onChange={(event) => setRepeatPassword(event.target.value)} />
              </p>
              {matchErrorEl}
              <ActionButton
                isSubmit
                extraClass="btn-primary" status={resetPasswordStatus}
                text={translate('reset_password_submit')} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

ResetPasswordPage.propTypes = {
  actions: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  resetPasswordStatus: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {resetPasswordStatus} = state.authReducer;
  const translate = getTranslate(state.localeReducer);
  return {
    resetPasswordStatus,
    translate,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordPage);
